module.exports = __webpack_public_path__ + "fondo.png?f104ce483bfdf94c6c1f43d781298650";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fondo.png
// module id = 689
// module chunks = 0